import { LayoutTableContainer } from '../orders/_layouts/LayoutTableContainer';
import { LayoutReviewContainer, LayoutReviewsBody } from '../orders/_layouts/LayoutsReviews';
import { Button } from '@/components/atoms/NewPcButton';
import ChangeBill from './ChangeBill';
import CancelMembership from './CancelMembership';
import { CPLAT_API_ROUTES, useFetch } from '@/api';
import { useAppSelector } from '@/redux/store';
import { GetPaymentInfoData } from '@/types/api';
import useCheckMembership from '@/hooks/useCheckMembership';
import EmptyFaceIcon from '@/assets/icons/EmptyFaceIcon.svg?react';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/utils/tailwind';

const mockData = [
  {
    status: '구독중',
    amount: '10,000원',
    payMethod: 'KAKAO PAY',
    payDate: '2025.06.18 02:23',
    period: '2025.06.18 ~ 2025.07.17',
  },
];

const MemberShipContainer = () => {
  const user = useAppSelector((state) => state.user);
  const isMember = useCheckMembership();

  const { data: res, isLoading } = useFetch<GetPaymentInfoData[]>(CPLAT_API_ROUTES.getPaymentInfo, {
    method: 'POST',
    params: {
      cplatToken: user.CplatToken,
      serviceName: '',
      orderByMethod: 0,
      take: 12, // 최근 1년치
    },
  });

  const paymentList1 = res?.data?.[0]?.PaymentList ?? [];
  // const paymentList2 = resSellerBox?.data?.[0]?.PaymentList ?? [];

  // const combinedData = [...paymentList1, ...paymentList2].sort(
  const combinedData = [...paymentList1].sort(
    (a, b) => new Date(b.PaymentDate).getTime() - new Date(a.PaymentDate).getTime(),
  );

  return (
    <LayoutTableContainer>
      <LayoutReviewContainer>
        <LayoutReviewsBody className="rounded-[20px] border border-gr-200">
          {combinedData.length === 0 ? (
            <EmptyList />
          ) : (
            <div className="flex h-full w-full flex-col items-start justify-start gap-[20px]  px-[16px] py-[20px]">
              <table className="w-full border-collapse overflow-hidden rounded-t-sm  shadow-none">
                <thead className="border-b border-gr-300">
                  <tr className="whitespace-nowrap bg-gr-50 text-gr-800">
                    <th className="whitespace-nowrap px-4 py-3 text-left text-gr-800 Caption1M12">
                      상태
                    </th>
                    <th className="whitespace-nowrap px-4 py-3 text-left text-gr-800 Caption1M12">
                      결제금액
                    </th>
                    <th className="whitespace-nowrap px-4 py-3 text-left text-gr-800 Caption1M12">
                      결제수단
                    </th>
                    <th className="whitespace-nowrap px-4 py-3 text-left text-gr-800 Caption1M12">
                      결제일시
                    </th>
                    <th className="whitespace-nowrap px-4 py-3 text-left text-gr-800 Caption1M12">
                      이용기간
                    </th>
                    {isMember && <th className="px-4 py-3 text-center"></th>}
                  </tr>
                </thead>
                <tbody>
                  {combinedData.map((row, idx) => {
                    const status = getStatus(row.Period);
                    return (
                      <tr
                        key={row.OrderNo ?? idx}
                        className="h-[60px] whitespace-nowrap border-b border-gr-200"
                      >
                        <td
                          className={cn('px-4 py-3 Body5M14', {
                            'text-point-500': status === '구독중',
                            'text-gr-500': status === '만료',
                          })}
                        >
                          {status}
                        </td>
                        <td className="px-4 py-3 text-gr-800 Body5M14">
                          {row.PaymentAmount?.toLocaleString()}원
                        </td>
                        <td className="px-4 py-3 text-gr-800 Body5M14">
                          {row.CardName || 'KAKAO PAY'}
                        </td>
                        <td className="px-4 py-3 text-gr-800 Body5M14">
                          {row.PaymentDate?.replace('T', ' ').slice(0, 16).replace(/-/g, '.')}
                        </td>
                        <td className="px-4 py-3 text-gr-800 Body5M14">{row.Period}</td>
                        {isMember && (
                          <td
                            className=" px-2.5 text-center
                          "
                          >
                            {idx === 0 && (
                              <div className="flex justify-end gap-[10px]">
                                <ChangeBill />
                                <CancelMembership />
                              </div>
                            )}
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </LayoutReviewsBody>
      </LayoutReviewContainer>
    </LayoutTableContainer>
  );
};

export default MemberShipContainer;

function getStatus(period: string): '구독중' | '만료' {
  // 예: "2025-06-04 ~ 2025-09-03"
  if (!period) return '만료';
  const [start, end] = period.split('~').map((s) => s.trim());
  const today = new Date();
  const startDate = new Date(start.replace(/\./g, '-'));
  const endDate = new Date(end.replace(/\./g, '-'));
  // 오늘이 startDate 이상, endDate 이하이면 구독중
  if (today >= startDate && today <= endDate) return '구독중';
  return '만료';
}

const EmptyList = () => {
  const navigate = useNavigate();

  return (
    <div className={cn('flex h-full w-full flex-col items-center justify-center gap-[20px]')}>
      <EmptyFaceIcon />
      <div className="text-gr-700 Body1S16">결제 내역이 없습니다</div>
      <Button
        size="small"
        variant="secondary"
        className="w-fit"
        onClick={() => navigate('/more/membership')}
      >
        멤버십 가입하기
      </Button>
    </div>
  );
};
